import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const money = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { setState("error"); return; }
      if (++tries < 8) setTimeout(poll, 2000); else setState("error");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-lg mx-auto py-12 text-center">
      <div className="card-flat p-10">
        {state === "checking" && (<><Loader2 size={48} className="mx-auto text-[#000091] animate-spin mb-4" /><h1 className="font-display font-black text-2xl mb-2">Vérification du paiement...</h1><p className="text-slate-500">Merci de patienter quelques secondes.</p></>)}
        {state === "paid" && (<>
          <CheckCircle2 size={56} className="mx-auto text-emerald-600 mb-4" />
          <h1 className="font-display font-black text-3xl mb-2">Paiement confirmé</h1>
          <p className="text-slate-600 mb-1">Montant réglé : <b>{money(data?.amount)}</b></p>
          {data?.invoice_number && <p className="text-slate-500 mb-6">Facture <b>{data.invoice_number}</b> générée.</p>}
          <button data-testid="payment-back-btn" onClick={() => nav("/app")} className="bg-[#000091] text-white px-6 py-3 font-semibold hover:bg-blue-900 transition-colors">Retour à mes dossiers</button>
        </>)}
        {state === "error" && (<>
          <XCircle size={56} className="mx-auto text-[#E1000F] mb-4" />
          <h1 className="font-display font-black text-2xl mb-2">Paiement non confirmé</h1>
          <p className="text-slate-500 mb-6">Le paiement n'a pas pu être vérifié. Vous pouvez réessayer depuis votre dossier.</p>
          <button onClick={() => nav("/app")} className="border border-[#000091] text-[#000091] px-6 py-3 font-semibold hover:bg-[#000091] hover:text-white transition-colors">Retour</button>
        </>)}
      </div>
    </div>
  );
}
